import { Trans } from 'react-i18next';
import { useApplication } from 'src/context/ApplicationContext';
import { useStepTranslations } from 'src/hooks/useClientTranslations';
import { Container, DividerLine, Row, StyledSubText, StyledText } from './styles';
const PUBLIC_URL = process.env.PUBLIC_URL;

const Success = () => {
  const { property, bankLinkingReportId } = useApplication();
  const { tStep } = useStepTranslations();

  return (
    <Container>
      <Row>
        <img src={`${PUBLIC_URL}/assets/images/success_squid.png`} alt="Squid Success" />
      </Row>

      <StyledText>{tStep('congrats')}</StyledText>
      <StyledSubText>
        {tStep('message', { property: property.name || 'The property' })}
      </StyledSubText>
      {bankLinkingReportId && (
        <>
          <DividerLine style={{ margin: '2rem 3rem' }} />
          <StyledSubText fontSize="16px" isStretched>
            <Trans>{tStep('reportMessage', { reportId: bankLinkingReportId })}</Trans>
          </StyledSubText>
        </>
      )}
    </Container>
  );
};

export default Success;
